import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { router } from "@inertiajs/react";
import * as _ from "lodash";

interface DataState {
    page: number;
    limit: number | string;
    orderBy: string;
    direction: string;
    search: string;
    route_url: string;
    loading: boolean;
    params?: object;
}

const initialState: DataState = {
    page: 1,
    limit: "",
    orderBy: "",
    direction: "",
    search: "",
    route_url: "",
    loading: false,
    params: {},
};

const dataSlice = createSlice({
    name: "data",
    initialState,
    reducers: {
        setRouteUrl: (state, action: PayloadAction<string>) => {
            state.route_url = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setLimit: (state, action: PayloadAction<number | string>) => {
            state.limit = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setDirection: (state, action: PayloadAction<string>) => {
            state.direction = action.payload;
        },
        setSearchTerm: (state, action: PayloadAction<string>) => {
            state.search = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setParams: (state, action) => {
            state.params = action.payload;
        },
    },
});

export const {
    setRouteUrl,
    setPage,
    setLimit,
    setOrderBy,
    setDirection,
    setSearchTerm,
    setLoading,
    setParams,
} = dataSlice.actions;

export const setData = () => (dispatch, getState) => {
    const state = getState().data;

    // Extract params using lodash pickBy, but keep search even if empty
    const baseParams = _.pickBy({
        page: state.page,
        limit: state.limit,
        orderBy: state.orderBy,
        direction: state.direction,
        ...state.params,
    });

    // Always include search parameter
    const params = {
        ...baseParams,
        search: state.search,
    };

    router.get(state.route_url, params, {
        preserveState: true,
        replace: true,
        onStart: () => {
            dispatch(setLoading(true)); // Set loading to true
        },
        onFinish: () => {
            dispatch(setLoading(false)); // Set loading to false
        },
        onSuccess: (page) => {
            // Optional: Handle any additional success logic
        },
        onError: (errors) => {
            // console.error(errors); // Handle errors
        },
    });
};

export default dataSlice.reducer;
